import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormattedMessage } from 'react-intl';
import { Button, Tooltip } from 'antd';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import messages from './messages';

const CopyToClipboardButton = ({ textToCopy, hideTooltip, children, ...buttonProps }) => {
  const [copied, setCopied] = useState(false);
  let timer = null;

  useEffect(() => () => {
    if (timer) {
      clearTimeout(timer);
    }
  }, []);

  const onCopy = () => {
    setCopied(true);
    timer = setTimeout(() => setCopied(false), 2000);
  };

  const tooltip = () => {
    if (hideTooltip) return '';
    return copied
      ? <FormattedMessage {...messages.copied} />
      : <FormattedMessage {...messages.copy} />;
  };

  return (
    <CopyToClipboard text={textToCopy} onCopy={onCopy}>
      <Tooltip title={tooltip()}>
        <Button {...buttonProps} icon={copied ? <CheckOutlined /> : <CopyOutlined />}>
          {children}
        </Button>
      </Tooltip>
    </CopyToClipboard>
  );
};

export default CopyToClipboardButton;
